"use strict";

import {DataAttrFilterRule, FilterSource, TextFilterRule} from "./groupsListFilter";

export default class SearchFilterSource extends FilterSource {

    constructor(input) {
        super()
        this.input = input
    }

    getActiveRules() {
        let options = $(this.input).data('filterOptions') || {}
        if ($(this.input).val()) {
            return [
                new TextFilterRule($.extend({
                    op: 'filter',
                    value: $(this.input).val().toLocaleLowerCase(),
                    weight: 50,
                }), options),
                new DataAttrFilterRule($.extend({
                    name: 'tags',
                    op: 'merge',
                    value: $(this.input).val(),
                    weight: 60,
                }, options)),
            ]
        } else {
            return []
        }
    }
}
